export default "<img class=\"svg-icon\" src=\"./assets/icon/{{icon}}.svg\" [style.transform]=\"'scale(' + scale + ')'\">\n"